import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    SaveButton,
    Description,
    Question,
    QuestionsList,
    QuestionTitle,
    Form,
} from 'src/domains/players/webview/components/Account/preferencesTab/MarketingQuestionsForm.style';
import { observer } from 'src/utils/mobx-react';
import { MarketingQuestionsState, QuestionModel } from 'src/domains/players/state/MarketingQuestionsState';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { SelectNew } from 'src/domains/players/webview/components/form/selectNew/SelectNew';

interface MarketingQuestionsItemPropsType {
    question: QuestionModel;
    marketingQuestionsState: MarketingQuestionsState;
}

const MarketingQuestionsItem = observer('MarketingQuestionsItem', (props: MarketingQuestionsItemPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);

    const { question } = props;

    return (
        <Question>
            <QuestionTitle data-test='question-title'>{question.name}</QuestionTitle>
            <SelectNew
                placeholder={languagesState.getTranslation(
                    'account.contact-preferences.marketing-select.label',
                    'Please select...'
                )}
                options={question.selectOptions}
                isDisabled={question.hasAnswer}
                hideIndicator={question.hasAnswer}
                inputState={question.input}
                defaultValue={question.userAnswer}
                dataTest='select'
            />
        </Question>
    );
});

interface PropsType {
    marketingQuestionsState: MarketingQuestionsState;
}

const preventDefault = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
};

export const MarketingQuestionsForm = observer('MarketingQuestionsForm', ({ marketingQuestionsState }: PropsType) => {
    return (
        <Form
            onSubmit={preventDefault}
            data-test='marketing-questions-form'
        >
            <Description data-test='description'>
                <I18n
                    langKey='account.contact-preferences-tab.marketing-desc'
                    defaultText='We will give you some special offers based on your preferences if we are able to contact you. If you need to change an answer you have to contact customer service.'
                />
            </Description>
            <QuestionsList>
                {marketingQuestionsState.allActiveQuestions.map((question) => (
                    <MarketingQuestionsItem
                        question={question}
                        marketingQuestionsState={marketingQuestionsState}
                        key={question.id}
                    />
                ))}
            </QuestionsList>
            {marketingQuestionsState.isSaveButtonDisplayed === true ? (
                <SaveButton
                    size='large'
                    disabled={!marketingQuestionsState.isSaveButtonEnabled}
                    type='submit'
                    onClick={marketingQuestionsState.updateQuestions}
                    dataTest='save-button'
                >
                    <I18n
                        langKey='account.contact-preferences.marketing-save.label'
                        defaultText='Save'
                    />
                </SaveButton>
            ) : null}
        </Form>
    );
});
